import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=1e4f2ef2&scoped=true&"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts&"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=1e4f2ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4f2ef2",
  null
  
)

export default component.exports